import React from 'react';
import cn from 'classnames';
import { formatAmount, AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR } from '@alfalab/utils';
import { logWarning } from './utils/logWarning.js';
import { trimTrailingZeros } from './utils/trimTrailingZeros.js';

var styles = {"component":"amount__component_1gvmg","transparentMinor":"amount__transparentMinor_1gvmg","bold":"amount__bold_1gvmg","normalMinor":"amount__normalMinor_1gvmg","defaultStyles":"amount__defaultStyles_1gvmg","defaultMinor":"amount__defaultMinor_1gvmg","minorPartAndCurrency":"amount__minorPartAndCurrency_1gvmg"};
require('./index.css')

/**
 * Компонент для отображения суммы, согласно следующему гайдлайну:
 * https://design.alfabank.ru/patterns/amount
 */
var Amount = function (_a) {
    var _b, _c;
    var value = _a.value, minority = _a.minority, currency = _a.currency, _d = _a.codeFormat, codeFormat = _d === void 0 ? 'symbolic' : _d, _e = _a.view, view = _e === void 0 ? 'default' : _e, bold = _a.bold, transparentMinor = _a.transparentMinor, rightAddons = _a.rightAddons, _f = _a.showPlus, showPlus = _f === void 0 ? false : _f, className = _a.className, _g = _a.trimZero, trimZero = _g === void 0 ? false : _g, dataTestId = _a.dataTestId;
    var _h = formatAmount({
        value: value,
        currency: currency,
        minority: minority,
        view: view,
        codeFormat: codeFormat,
    }), majorPart = _h.majorPart, minorPart = _h.minorPart, currencySymbol = _h.currencySymbol, currencySeparator = _h.currencySeparator;
    var defaultStyles = bold === undefined && transparentMinor === undefined;
    logWarning(currency);
    return (React.createElement("span", { className: cn(styles.component, className, (_b = {},
            _b[styles.bold] = bold === 'full' || bold === 'major',
            _b[styles.defaultStyles] = defaultStyles,
            _b)), "data-test-id": dataTestId },
        showPlus && value > 0 ? '+' : '',
        majorPart,
        React.createElement("span", { className: cn(styles.minorPartAndCurrency, (_c = {},
                _c[styles.transparentMinor] = transparentMinor,
                _c[styles.normalMinor] = bold === 'major',
                _c[styles.defaultMinor] = defaultStyles,
                _c)) },
            minorPart && AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR,
            trimZero ? trimTrailingZeros(minorPart) : minorPart,
            currency ? "".concat(currencySeparator).concat(currencySymbol !== null && currencySymbol !== void 0 ? currencySymbol : currency) : null,
            rightAddons)));
};

export { Amount };
